import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white text-gray-800 py-6 shadow-lg">
   <div className="text-center">
          <p>By Uzer Nizamuddin Qureshi © 2024/2025</p>
        </div>
    </footer>
  );
};

export default Footer;
